import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const StatePage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.State}
        fetchRecordsUrl={AdminReqUrls.admin__state__mainPage_fetch_recordList}
    />)
});
export default StatePage;
